import { REPORT_ACTION_DISABLED_HINTS } from '@/domains/reports/constants/report-option-tooltips';

export const SYSTEM_REPORT_CREATOR = 'system';
export const REPORT_WITH_DEFAULT_ID_READONLY_MESSAGE =
  'System reports are read-only. You can update timerange and filters locally, but you cannot edit or delete the report.';
export const REPORT_SYSTEM_ACTIONS_DISABLED_MESSAGE = REPORT_ACTION_DISABLED_HINTS.systemReportEdit;
export const REPORT_SYSTEM_PRIVATE_DISABLED_MESSAGE = REPORT_ACTION_DISABLED_HINTS.systemReportMakePrivate;
export const SYSTEM_REPORT_CHART_DELETE_DISABLED_MESSAGE = 'Charts in system reports cannot be deleted.';

type ReportCreatorLike = {
  created_by?: string | null;
  createdBy?: string | null;
};

type ReportDefaultIdLike = {
  default_id?: string | null;
};

type ReportSharePublishLike = ReportDefaultIdLike & {
  is_private?: boolean | null;
};

export function isSystemReport(report: ReportCreatorLike | null | undefined, explicitCreator?: string | null): boolean {
  const creator = explicitCreator ?? report?.created_by ?? report?.createdBy;
  return (creator ?? '').trim().toLowerCase() === SYSTEM_REPORT_CREATOR;
}

export function isDefaultIdReadOnlyReport(report: ReportDefaultIdLike | null | undefined): boolean {
  return report?.default_id !== undefined && report?.default_id !== null;
}

export function canUpdateReportIcon<T extends ReportDefaultIdLike>(report: T | null | undefined): report is T {
  return !!report && !isDefaultIdReadOnlyReport(report);
}

export function shouldPublishReportOnShare(report: ReportSharePublishLike | null | undefined): boolean {
  if (!report) return false;
  if (isDefaultIdReadOnlyReport(report)) return false;
  return report.is_private === true;
}
